<!-- 公共头部 -->
<template>
    <div class="headerBox">
        <div class="changeLanguageBox" @click.stop="changeLang">
            <i class="iconfont icon-a-qiehuan1 changeLanguageIcon"></i>
            <div>{{ $t('common.language') }} | {{ currentLocale.label }}</div>
        </div>
        <template v-if="info.titleImage">
            <img class="headerBg" :src="validateImageUrl(info.titleImage)" />
        </template>
        <template v-else>
            <img class="headerBg" src="../../assets/images/headerBg.png" />
        </template>
        <div class="headerTitle">{{ $t("common.traceabilityDetails") }}</div>
        <changeLocalesPicker ref="changeLocalesPickerRef" />
    </div>
</template>

<script>
import { LANGUAGE_LIST } from "@/utils/constant.js";
import changeLocalesPicker from "@/components/page/modules/changeLocalesPicker.vue";
import { validateImageUrl } from "@/utils/index.js";
export default {
    components: {
        changeLocalesPicker,
    },
    props: {
        info: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            localesList: LANGUAGE_LIST, // 国际化 - 语言切换
        };
    },
    computed: {
        currentLocale() {
            return this.localesList.find((item) => item.value == (this.$i18n.locale || 'zh-CN'));
        },
    },
    methods: {
        /**
        * 切换语言
        */
        changeLang() {
            this.$refs.changeLocalesPickerRef.showPicker();
        },
        /**
         * 验证图片URL是否有效
         * @param {string} url - 图片URL
         * @returns {string} - 验证后的图片URL
         */
        validateImageUrl(url) {
            return validateImageUrl(url);
        }
    },
};
</script>

<style scoped>
.headerBox {
    width: 100%;
    height: 200px;
    position: relative;
    z-index: 1;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.changeLanguageBox {
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: inherit;
    width: fit-content;
    border-radius: 16.73px;
    background: rgba(255, 255, 255, 0.15);
    padding: 4px 7px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    color: #ffffff;
    margin-top: 10px;
}

.changeLanguageIcon {
    font-size: 10px;
    color: #ffffff;
}

.changeLanguageBox div {
    font-size: 10px;
    margin: 0 5px;
}

.headerBg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
}

.headerTitle {
    font-size: 35px;
    font-weight: 400;
    letter-spacing: 0px;
    line-height: 36.65px;
    color: rgba(255, 255, 255, 1);
    z-index: inherit;
}
</style>